import { Deserializable } from '../protocols/deserializable';
import { PaymentMethodScheduledContributionUsage } from './payment-method-scheduled-contribution-usage';
import { PaymentMethodAnnuityUsage } from './payment-method-annuity-usage';
import { PaymentMethodVariableBenefitUsage } from './payment-method-variable-benefit-usage';
import { PaymentMethodSubmissionUsage } from './payment-method-submission-usage';

export class PaymentMethodUsage implements Deserializable {
  public scheduledContributions: PaymentMethodScheduledContributionUsage[] = [];
  public annuityAccounts: PaymentMethodAnnuityUsage[] = [];
  public variableBenefitAccounts: PaymentMethodVariableBenefitUsage[] = [];
  public submissions: PaymentMethodSubmissionUsage[] = [];

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    this.scheduledContributions =
      Deserialize?.arrayOf(PaymentMethodScheduledContributionUsage, this.scheduledContributions ?? []) ?? [];
    this.annuityAccounts = Deserialize?.arrayOf(PaymentMethodAnnuityUsage, this.annuityAccounts ?? []) ?? [];
    this.variableBenefitAccounts =
      Deserialize?.arrayOf(PaymentMethodVariableBenefitUsage, this.variableBenefitAccounts ?? []) ?? [];
    this.submissions = Deserialize?.arrayOf(PaymentMethodSubmissionUsage, this.submissions ?? []) ?? [];
  }
}
